<template>
  <div>
    <img
      v-if="isGolfService"
      class="logo-img"
      src="@/assets/golf/spotv-now-golf.png"
    />
    <img v-else class="logo-img" src="@/assets/logo-spotvnow-l.png" />
  </div>
</template>

<script>
import { getDeviceType, isGolf } from "../utils/common";

export default {
  data() {
    return {
      isActiveVue: true,
      delayTime: 2000,
      isGolfService: isGolf,
    };
  },
  methods: {
    goToNotice() {
      const self = this;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        self.$router.replace({
          name: "notice",
          params: {
            t: new Date().getTime(),
          },
        });
      }, this.delayTime);
    },
  },
  created() {
    this.$store.dispatch("FETCH_LAMBDA_INFO").then((response) => {
      if (response?.data?.d_url && getDeviceType() === "samsung") {
        this.$router.replace({
          name: "samsungUpdate",
          params: {
            d_url: response.data.d_url,
          },
        });
      } else {
        this.goToNotice();
      }
    });
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.logo-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 70px;
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .logo-img {
    height: 56px;
  }
}
</style>
